import React from "react";

import { Dropdown, Input } from "lib/components/vendor";
import * as st from "lib/utils/socialtravel";

export default class SelectCompanyDropdown extends React.PureComponent {
  handleChange(event, { value }) {
    const { companies, onChange } = this.props;
    if (event.key !== "ArrowDown" && event.key !== "ArrowUp") {
      onChange && onChange(companies.find((c) => c.id === +value));
    }
  }

  render() {
    const { companies, onChange, value, ...props } = this.props;
    const options = [...companies]
      .sort((a, b) => (b.name.toLowerCase() < a.name.toLowerCase() ? 1 : -1))
      .map((c) => ({
        key: c.id,
        text: c.name,
        value: c.id,
        image: st.getAttachmentImageUrl(c, "logo_image", "thumb"),
      }));

    return (
      <Dropdown
        fluid
        basic
        search={companies.length > 5}
        value={value && value.id}
        onChange={this.handleChange.bind(this)}
        options={options}
        noResultsMessage={null}
        {...props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/SelectCompanyDropdown.jsx